import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Profile.vue'
import Admin from '../views/Admin.vue'
import SharesView from '../views/SharesView.vue'
import Setup from '../views/Setup.vue'
import OidcCallback from '../views/OidcCallback.vue'
import ListDetailView from '../views/ListDetailView.vue'
import ListView from '../views/ListView.vue'

const routes = [
  {
    path: '/',
    redirect: '/lists'
  },
  {
    path: '/setup',
    name: 'Setup',
    component: Setup
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/auth/callback',
    name: 'OidcCallback',
    component: OidcCallback
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/shares',
    name: 'SharesView',
    component: SharesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/shared/:link_id',
    name: 'SharedView',
    component: ListDetailView,
    props: route => ({
      shared: true,
      link_id: route.params.link_id,
      hmac: route.query.hmac
    })
  },
  {
    path: '/lists',
    name: 'ListView',
    component: ListView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lists/:uuid',
    name: 'ListDetailView',
    component: ListDetailView,
    meta: { requiresAuth: true },
    props: route => ({
      shared: false,
      listId: route.params.uuid
    })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  try {
    await authStore.initializeAuth()

    if (authStore.setupRequired && to.name !== 'Setup') {
      next('/setup')
      return
    }

    if (!authStore.setupRequired && to.name === 'Setup') {
      next('/login')
      return
    }
  } catch (error) {
    console.warn('Could not initialize authentication:', error)
  }
  
  // Allow print route for shared links without auth
  const isSharedPrint = to.name === 'PrintView' && to.query.link_id && to.query.hmac
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated && !isSharedPrint) {
    if (authStore.oidcLoginEnabled && authStore.oidcAutoRedirect) {
      try {
        await authStore.startOidcLogin()
        return
      } catch (error) {
        next({ path: '/login', query: { oidc_error: error.response?.data?.detail || error.message } })
        return
      }
    }
    next('/login')
  } else if ((to.name === 'Login' || to.name === 'Register') && authStore.isAuthenticated) {
    next('/lists')
  } else if (to.name === 'Register' && !authStore.registrationEnabled) {
    next('/login')
  } else if (to.meta.requiresAdmin && authStore.user?.role !== 'ADMIN') {
    next('/lists')
  } else {
    next()
  }
})

export default router
